import { InteractionManager, Platform } from 'react-native';

/**
 * On iOS, Firestore merges + HTTPS callables occasionally appear to hang until something else
 * (e.g. app background) wakes the RN event loop — often interaction/layout competing with outbound fetches.
 * Yield after current interactions finish and one animation frame before scheduling network work.
 */
export async function yieldIosOutboundFirebaseWork(): Promise<void> {
  if (Platform.OS !== 'ios') return;
  await new Promise<void>((resolve) => {
    InteractionManager.runAfterInteractions(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}
